import React from "react";
import { Tooltip } from "react-tooltip";

function ShowIcon(props) {
  return (
    <div
      className={props.className}
      onClick={() => props.onIconClick()}
      data-tooltip-id={props?.tooltip_id}
      data-tooltip-content={props?.tooltip_content}
      style={{ cursor: "pointer" }}
    >
      {/* <img
        src={props?.iconName}
        alt={props?.tooltip_content}
        className={props?.imgClassName}
        style={{ width: "20px", height: "20px" }}
      /> */}
      {props?.iconName}
      <Tooltip place="top" effect="float" id={props?.tooltip_id} />
    </div>
  );
}

export default ShowIcon;
